/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponsePlanItem
 */
export interface ResponsePlanItem {
    /**
     * 
     * @type {number}
     * @memberof ResponsePlanItem
     */
    boxCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsePlanItem
     */
    boxHeight?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsePlanItem
     */
    boxLength?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsePlanItem
     */
    boxWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsePlanItem
     */
    boxWidth?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsePlanItem
     */
    planName?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePlanItem
     */
    shipNum?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePlanItem
     */
    shippedDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePlanItem
     */
    userName?: string;
}

/**
 * Check if a given object implements the ResponsePlanItem interface.
 */
export function instanceOfResponsePlanItem(value: object): value is ResponsePlanItem {
    return true;
}

export function ResponsePlanItemFromJSON(json: any): ResponsePlanItem {
    return ResponsePlanItemFromJSONTyped(json, false);
}

export function ResponsePlanItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePlanItem {
    if (json == null) {
        return json;
    }
    return {
        
        'boxCount': json['box_count'] == null ? undefined : json['box_count'],
        'boxHeight': json['box_height'] == null ? undefined : json['box_height'],
        'boxLength': json['box_length'] == null ? undefined : json['box_length'],
        'boxWeight': json['box_weight'] == null ? undefined : json['box_weight'],
        'boxWidth': json['box_width'] == null ? undefined : json['box_width'],
        'planName': json['plan_name'] == null ? undefined : json['plan_name'],
        'shipNum': json['ship_num'] == null ? undefined : json['ship_num'],
        'shippedDate': json['shipped_date'] == null ? undefined : json['shipped_date'],
        'userName': json['user_name'] == null ? undefined : json['user_name'],
    };
}

export function ResponsePlanItemToJSON(json: any): ResponsePlanItem {
    return ResponsePlanItemToJSONTyped(json, false);
}

export function ResponsePlanItemToJSONTyped(value?: ResponsePlanItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'box_count': value['boxCount'],
        'box_height': value['boxHeight'],
        'box_length': value['boxLength'],
        'box_weight': value['boxWeight'],
        'box_width': value['boxWidth'],
        'plan_name': value['planName'],
        'ship_num': value['shipNum'],
        'shipped_date': value['shippedDate'],
        'user_name': value['userName'],
    };
}

